export default class DataService {
  _data = {
    projectRepo: 'https://github.com/batuhanyslyrt0',
    react95Repo: 'https://github.com/React95/React95',
    items: [
      {
        id: 'about',
        name: 'About.txt',
        icon: 'user',
        content: {
          paragraphs: [
            "Selam, ben Batuhan 👋",
            "İstanbul merkezli; modern web ve mobil teknolojileri, ölçeklenebilir altyapılar ve özel iş otomasyonları geliştiren bir Full-Stack & Mobil Yazılım Geliştiricisiyim.",
            "Next.js, React, Node.js, mobil uygulama (iOS/Android) ve veritabanı mimarileriyle e-ticaret platformlarından özgün dijital projelere kadar uçtan uca yüksek performanslı sistemler tasarlıyorum.",
            "Nostaljik tasarımları ve modern mühendislik yaklaşımlarını bir araya getirmeyi seviyorum. Projelerimde hız, temiz mimari ve kullanıcı deneyimini ön planda tutuyorum."
          ],
        },
      },
      {
        id: 'photos',
        name: 'Photos.jpg',
        icon: 'progman_24',
      },
      {
        id: 'resume',
        name: 'Resume.txt',
        icon: 'notepad_2',
        content: {
          resumeLink: '',
          workExperience: [
            {
              jobTitle: 'Full-Stack & Mobile Developer',
              company: 'Freelance',
              location: 'İstanbul',
              period: '2024 – Devam Ediyor',
              accomplishments: [
                'K-Design (k-design.com.tr) premium oto koltuk kılıfı e-ticaret platformunun web altyapısı ile iOS (App Store) ve Android (Google Play) mobil uygulamalarının uçtan uca geliştirilmesi ve yayınlanması',
                'Berber Randevu & Yönetim Sistemi (berber.batudev.com) web ve WhatsApp entegrasyonlu randevu platformunun geliştirilmesi',
                'Capacitor ile cross-platform mobil uygulama mimarisi, push notification ve App Store / Google Play Console mağaza dağıtım süreçleri',
                'Next.js, React, Node.js, TypeScript, PostgreSQL ile modern web ve mobil sistemler geliştirme',
                'Responsive tasarım, SEO optimizasyonu ve performans iyileştirmeleri',
              ],
            },
          ],
        },
      },
      {
        id: 'projects',
        name: 'Projects.txt',
        icon: 'flying_through_space_100',
        content: {
          projects: [
            {
              title: 'K-Design E-Ticaret & Mobil Uygulamaları',
              description:
                'Premium oto koltuk kılıfı ve aksesuarları platformu. Kapsamlı web e-ticaret altyapısının yanı sıra App Store ve Google Play Store üzerinde canlıda olan resmi iOS ve Android mobil uygulamaları.',
              myRole: 'Full-Stack & Mobile Developer',
              techStack: 'Next.js, React, Node.js, Capacitor, iOS, Android, PostgreSQL, TailwindCSS',
              url: 'https://k-design.com.tr',
              appStoreUrl: 'https://apps.apple.com/tr/app/k-design/id6813559819?l=tr',
              playStoreUrl: 'https://play.google.com/store/apps/details?id=com.kdesign.tr',
            },
            {
              title: 'Berber Randevu & Yönetim Sistemi',
              description:
                'Erkek kuaförleri ve salonlar için online ve WhatsApp entegrasyonlu anlık randevu alma, hizmet seçimi ve işletme yönetim platformu.',
              myRole: 'Full-Stack Developer',
              techStack: 'Next.js, React, Node.js, WhatsApp API, TailwindCSS',
              url: 'https://berber.batudev.com',
            },
            {
              title: 'batudev.com (Win95 Portfolio)',
              description:
                'Windows 95 temalı kişisel portfolio sitesi. Evet, şu an baktığınız bu site!',
              techStack: 'React, React95, WebAmp',
              repo: 'https://github.com/batuhanyslyrt0',
            },
          ],
        },
      },
      {
        id: 'skills',
        name: 'Skills.txt',
        icon: 'progman_11',
        content: {
          hard: [
            { name: 'JavaScript', progress: 95 },
            { name: 'React', progress: 90 },
            { name: 'Next.js', progress: 90 },
            { name: 'Node.js', progress: 85 },
            { name: 'TypeScript', progress: 85 },
            { name: 'Mobil (iOS & Android)', progress: 85 },
            { name: 'Capacitor', progress: 85 },
            { name: 'HTML/CSS', progress: 95 },
            { name: 'TailwindCSS', progress: 90 },
            { name: 'PostgreSQL / SQL', progress: 80 },
            { name: 'Git', progress: 85 },
            { name: 'Docker', progress: 65 },
          ],
          soft: 'Öğrenmeye aç, problem çözmeye tutkulu bir geliştiriciyim. Takım çalışmasına yatkınım ve yeni teknolojileri keşfetmeyi seviyorum. Her bug bir macera, her deploy bir zafer! 🚀',
        },
      },
      {
        id: 'contact',
        name: 'Contact.txt',
        icon: 'inetcfg_2301',
        content: {
          emailText:
            'Bir proje fikrin mi var? Yoksa sadece merhaba mı demek istiyorsun? Her türlü yaz! ',
          email: 'batuhan.yesilyurt@outlook.com',
          socialText: 'Veya sosyal medyadan ulaş:',
          social: [
            {
              name: 'FaGithub',
              link: 'https://github.com/batuhanyslyrt0',
            },
            {
              name: 'FaLinkedin',
              link: 'https://tr.linkedin.com/in/batuhan-ye%C5%9Filyurt-597160284',
            },
            {
              name: 'FaInstagram',
              link: 'https://www.instagram.com/batuhanyslyrt0',
            },
          ],
        },
      },
      {
        id: 'admin',
        name: 'Admin.exe',
        icon: 'key_1',
        content: {},
      },
    ],
  };

  getItems() {
    return this._data.items.filter((x) => x.id !== 'admin').map(({ id, name, icon }) => ({ id, name, icon }));
  }

  getItem(id) {
    return this._data.items.find((x) => x.id === id);
  }

  getProjectInfo() {
    return {
      projectRepo: this._data.projectRepo,
      react95Repo: this._data.react95Repo,
    };
  }
}
